import { render, staticRenderFns } from "./UserDetailBarChartTile.vue?vue&type=template&id=290a5bd1&scoped=true&lang=pug&"
import script from "./UserDetailBarChartTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailBarChartTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailBarChartTile.vue?vue&type=style&index=0&id=290a5bd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a5bd1",
  null
  
)

export default component.exports